import {Brand, DateFilter, PremiumService} from "@App/types";
import {Action} from "@App/state/actions";
import {ActionType} from "@App/state/action-types";
import {SortOrderType} from "@App/types/enums";

interface FilterReducerState {
    distance: number
    search?: string
    dates?: DateFilter
    premiumServices?: PremiumService[]
    brand?: Brand
    sortBy: SortOrderType
    bevSupport: boolean
    commercialVehicleSupport: boolean
    modalDismissed: boolean
    onlyBookable: boolean
    onlyManufacturer: boolean
    showAsNonBookable: boolean
}

/**
 * getInitialSorting returns the initial sorting from the config window object
 * as the orderReducer organization object isn't available at time of initialization.
 */
const getInitialSorting = (): SortOrderType => {
    const defaultSorting = window.organization?.settings.garage_list.default_sorting;

    return Object.values(SortOrderType).includes(defaultSorting as SortOrderType)
        ? (defaultSorting as SortOrderType)
        : SortOrderType.SMALLEST_DISTANCE;
}

const initialState: FilterReducerState = {
    distance: 30000,
    search: '',
    dates: null,
    brand: null,
    premiumServices: [],
    sortBy: getInitialSorting(),
    bevSupport: false,
    commercialVehicleSupport: false,
    modalDismissed: false,
    onlyBookable: false,
    onlyManufacturer: false,
    showAsNonBookable: false
}

const filterReducer = (state: FilterReducerState = initialState, action: Action) => {
    switch (action.type) {
        // modal actions
        case ActionType.DISMISS_MODAL:
            return {
                ...state,
                modalDismissed: action.payload
            }
        // filter actions
        case ActionType.CHANGE_DATES_FILTER:
            return {
                ...state,
                dates: action.payload
            }
        case ActionType.CHANGE_DISTANCE_FILTER:
            if (state.distance !== action.payload) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'change radius',
                    'sorting': action.payload
                });
            }
            return {
                ...state,
                distance: action.payload
            }
        case ActionType.CHANGE_NAME_FILTER:
            return {
                ...state,
                search: action.payload
            }
        case ActionType.CHANGE_SORT_BY_FILTER:
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'change sorting',
                'sorting': action.payload
            });
            return {
                ...state,
                sortBy: action.payload
            }
        case ActionType.CHANGE_BRAND_FILTER:
            return {
                ...state,
                brand: action.payload
            }
        case ActionType.CHANGE_BEV_SUPPORT_FILTER:
            return {
                ...state,
                bevSupport: action.payload
            }
        case ActionType.CHANGE_COMMERCIAL_VEHICLE_SUPPORT_FILTER:
            return {
                ...state,
                commercialVehicleSupport: action.payload
            }
        case ActionType.CHANGE_BOOKABLE_FILTER:
            return {
                ...state,
                onlyBookable: action.payload
            }
        case ActionType.CHANGE_ONLYMANUFACTURER_FILTER:
            return {
                ...state,
                onlyManufacturer: action.payload
            }
        case ActionType.SET_GARAGE_CHAINS:
            return {
                ...state,
                garage_chain: action.payload
            }
        case ActionType.CHANGE_SHOW_AS_NONBOOKABLE:
            return {
                ...state,
                showAsNonBookable: action.payload
            }
    }
    return state
}

export default filterReducer
